export interface TabOption {
	// allow index-accessing for custom props
	[key: string]: unknown;
	uuid?: string;
	name: string;
	count?: number;
	link?: string;
}
